import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import IHttpResponse from '../../interfaces/shared/IHttpResponse';
import { ISuperGuaranteeBody } from '../../interfaces/request/ISuperGuarantee.interface';

export interface ISaleBody {
  body: {
    duracionPoliza: number;
  },
  process: {
    tomadorPago: number;
    idCliente: number;
    idPersona: number;
  }
}

export interface IGetDuracionPolizasResponse {
  id: number;
  alias: string;
  descripcion: string;
}

@Injectable({
  providedIn: 'root'
})
export class ContratarService {

  baseUrl = `${environment.baseUrl}`;
  apiUrl = `${environment.ApiPricing}`;
  url: string;

  constructor(private http: HttpClient) {
    this.url = this.baseUrl + this.apiUrl;
  }

  /**
   * @param body   {idCotizacion,tomadorPago,fraccionPago,duracionPoliza}
   */
  contratar(idCotizacion: number, idCotizacionModalidadFraccionPago: number, body: ISaleBody): Observable<any> {
    const url = `${this.url}/ContractQuotation/${idCotizacion}/${idCotizacionModalidadFraccionPago}`;
    return this.http.post<any>(url, body);
  }

  getDuracionPolizas() {
    return this.http.get<IHttpResponse<IGetDuracionPolizasResponse[]>>(`${this.url}/GetDurationPolicies`)
  }

  contractSuperguarantee(contractData: ISuperGuaranteeBody){

    const url = `${this.url}/contract/superGuarantee`;
    
    return this.http.post<any>(url, contractData);
  }
}
